<template lang="pug">
AppModal(:value="value" @input="$emit('input', $event)" title="Importar Precios de Tiendas")
  .import-modal-content
    p.mb-3 Selecciona un archivo de Excel (.xlsx) con los precios de tiendas para importar.
    
    b-form-file(
      v-model="file"
      placeholder="Elige un archivo o arrástralo aquí..."
      drop-placeholder="Suelta el archivo aquí..."
      accept=".xlsx"
      class="mb-3"
    )

    .alert.alert-danger(v-if="errorMsg") {{ errorMsg }}
    .alert.alert-success(v-if="successMsg") {{ successMsg }}
    
    .errors-container.mt-2(v-if="errors.length" style="max-height: 150px; overflow-y: auto;")
      ul.text-danger.p-0.pl-3
        li(v-for="(err, idx) in errors" :key="idx" style="font-size: 0.9rem;") {{ err }}

    .d-flex.justify-content-end.mt-4
      AppButton(outline @click="close" class="mr-2") Cancelar
      AppButton(:disabled="!file || loading" @click="handleImport")
        span(v-if="loading") Importando...
        span(v-else) Importar
</template>

<script>
import AppModal from '@/components/UI/AppModal.vue'
import AppButton from '@/components/UI/AppButton.vue'
import { mapActions } from 'vuex'

export default {
  name: 'ModalImportStorePrices',
  components: {
    AppModal,
    AppButton
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      file: null,
      loading: false,
      errorMsg: '',
      successMsg: '',
      errors: []
    }
  },
  watch: {
    value(isOpen) {
      if (isOpen) {
        this.reset()
      }
    }
  },
  methods: {
    ...mapActions(['importStorePricesExcel']),
    reset() {
      this.file = null
      this.loading = false
      this.errorMsg = ''
      this.successMsg = ''
      this.errors = []
    },
    close() {
      this.$emit('input', false)
    },
    async handleImport() {
      if (!this.file) return
      this.loading = true
      this.errorMsg = ''
      this.successMsg = ''
      this.errors = []

      const formData = new FormData()
      formData.append('file', this.file)

      try {
        const response = await this.importStorePricesExcel({ data: formData })
        
        if (response.status === 200) {
          const result = response.data
          if (result.success) {
            this.successMsg = `Importación completada. Se procesaron ${result.processedRows} filas.`
            if (result.errors && result.errors.length > 0) {
              this.errors = result.errors
              this.errorMsg = 'Algunas filas no pudieron ser importadas:'
            } else {
              this.$emit('success')
              setTimeout(() => {
                this.close()
              }, 2000)
            }
          } else {
            this.errorMsg = 'Error en el procesamiento del archivo.'
          }
        } else {
          const errMsg = response.data && response.data.message ? response.data.message : 'Error al conectar con el servidor.'
          this.errorMsg = errMsg
        }
      } catch (err) {
        this.errorMsg = 'Error inesperado al subir el archivo.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.import-modal-content {
  font-family: inherit;
}
</style>
